import { render, staticRenderFns } from "./DenormalizedChild.vue?vue&type=template&id=f180e5ae&"
import script from "./DenormalizedChild.vue?vue&type=script&lang=js&"
export * from "./DenormalizedChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports